import { Icon } from "@fluentui/react";
import { useParams } from "react-router-dom";
import { getUserLang, isNullOrEmpty } from "../../lib/helper";
import { useInjectedService } from "../../services/ioc/service-dependency";
import ImageTeaser from "../image-teaser/image-teaser";

import "./prepare.css";

const Prepare = () => {
  const { localizationService } = useInjectedService();
  let { culture, location } = useParams();

  if (
    isNullOrEmpty(culture) ||
    culture === undefined
  ) {
    culture = getUserLang();
  }

  var pdfCulture = "en";
  if (culture !== undefined && localizationService.isValidCulture(culture)) {
    pdfCulture = culture;
  }

  let faqUrl = "";
  let recommendedAppsUrl = "";
  if (
    !isNullOrEmpty(culture) &&
    culture !== undefined &&
    localizationService.isValidCulture(culture)
  ) {
    faqUrl = "/" + culture;
    recommendedAppsUrl = "/" + culture;
  }
  if (!isNullOrEmpty(location) && location !== undefined && localizationService.isValidCountry(location)) {
    faqUrl += "/" + location;
    recommendedAppsUrl += "/" + location;
  }

  faqUrl += "/faq"+ window.location.search;
  recommendedAppsUrl += "/recommended" + window.location.search;

  return (
    <div className="bbraun-prepare-page">
      <div className="row bbraun-sand-bg">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-prepare-hero bbraun-prepare-desc-container">
            <div className="bbraun-hero-subtitle">
              {localizationService.getLocalizedText("GetStartedLabel")}
            </div>
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("GetStartedHeadline")}
            </div>
            <div
              className="bbraun-hero-content"
              dangerouslySetInnerHTML={{
                __html: localizationService.getLocalizedText("GetStartedDesc"),
              }}
            />
          </div>
        </div>
      </div>
      <div className="row ">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-prepare-hero bbraun-prepare-desc-container">
            <div className="bbraun-hero-subtitle">
              {localizationService.getLocalizedText("PrepareLabel")}
            </div>
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("PrepareHeadline")}
            </div>
            <div
              className="bbraun-hero-content"
              dangerouslySetInnerHTML={{
                __html: localizationService.getLocalizedText("PrepareDesc"),
              }}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-prepare-hero bbraun-prepare-hero-accept-steps">
            <div className="bbraun-prepare-hero-accept-step">
              <div>
                <Icon
                  className="bbraun-prepare-hero-accept-step-icon"
                  iconName="Accept"
                />
              </div>
              <div className="bbraun-prepare-hero-accept-step-content">
                <div className="bbraun-prepare-hero-accept-step-title">
                  {localizationService.getLocalizedText("PrepareStep1Title")}
                </div>
                <div
                  className="bbraun-prepare-hero-accept-step-desc"
                  dangerouslySetInnerHTML={{
                    __html:
                      localizationService.getLocalizedText("PrepareStep1Desc"),
                  }}
                />
              </div>
            </div>
            <div className="bbraun-prepare-hero-accept-step">
              <div>
                <Icon
                  className="bbraun-prepare-hero-accept-step-icon"
                  iconName="Accept"
                />
              </div>
              <div className="bbraun-prepare-hero-accept-step-content">
                <div className="bbraun-prepare-hero-accept-step-title">
                  {localizationService.getLocalizedText("PrepareStep3Title")}
                </div>
                <div
                  className="bbraun-prepare-hero-accept-step-desc"
                  dangerouslySetInnerHTML={{
                    __html:
                      localizationService.getLocalizedText("PrepareStep3Desc"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row bbraun-hero-row bbraun-sand-bg">
        <div className="col-sm">
          <div className="bbraun-hero">
            <div className="image-teaser-cluster-two-rows">
              <div className="image-teaser-wrapper bottom-headline">
                <div className="cmp-container">
                  <ImageTeaser
                    image={require("../../assets/images/Recommended.jpg")}
                    headline={localizationService.getLocalizedText(
                      "RecommendedLinkLabel"
                    )}
                    text={localizationService.getLocalizedText(
                      "RecommendedLinkText"
                    )}
                    link={recommendedAppsUrl}
                    objectfit={true}
                  />
                  <ImageTeaser
                    image={require("../../assets/images/privatephoneatwork.jpg")}
                    headline={localizationService.getLocalizedText(
                      "PrivatePhoneAtWorkLabel"
                    )}
                    text={localizationService.getLocalizedText(
                      "PrivatePhoneAtWorkText"
                    )}
                    link={require("../../assets/files/BKCApp_Onepager_" +
                      pdfCulture +
                      ".pdf")}
                    objectfit={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-prepare-hero">
            <div className="bbraun-hero-subtitle">
              {localizationService.getLocalizedText("ManualLabel")}
            </div>
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("ManualHeadline")}
            </div>
          </div>
        </div>
      </div>
      <div className="row bbraun-hero-row">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-prepare-hero bbraun-prepare-hero-image-teaser">
            <div className="image-teaser-cluster">
              <div className="image-teaser-wrapper bottom-headline">
                <div className="cmp-container">
                  <ImageTeaser
                    image={require("../../assets/images/OnlyNotebook.jpg")}
                    headline={localizationService.getLocalizedText(
                      "PrepareLinkOnlyNotebookLabel"
                    )}
                    text={localizationService.getLocalizedText(
                      "PrepareLinkOnlyNotebookText"
                    )}
                    link={require("../../assets/files/Manual_MFA_Laptop_only_" +
                      pdfCulture +
                      ".pdf")}
                    objectfit={true}
                  />
                  <ImageTeaser
                    image={require("../../assets/images/NotebookAndSmartphone.jpg")}
                    headline={localizationService.getLocalizedText(
                      "PrepareLinkNotebookAndSmartphoneLabel"
                    )}
                    text={localizationService.getLocalizedText(
                      "PrepareLinkNotebookAndSmartphoneText"
                    )}
                    link={require("../../assets/files/Manual_MFA_Laptop_and_Smartphone_" +
                      pdfCulture +
                      ".pdf")}
                    objectfit={true}
                  />
                  <ImageTeaser
                    image={require("../../assets/images/OnlySmartphone.jpg")}
                    headline={localizationService.getLocalizedText(
                      "PrepareLinkOnlySmartphoneLabel"
                    )}
                    text={localizationService.getLocalizedText(
                      "PrepareLinkOnlySmartphoneText"
                    )}
                    link={require("../../assets/files/Manual_MFA_Smartphone_only_" +
                      pdfCulture +
                      ".pdf")}
                    objectfit={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row bbraun-sand-bg">
        <div className="col-sm">
          <div className="bbraun-hero">
            <div className="bbraun-hero-subtitle">
              {localizationService.getLocalizedText("MFAAuth")}
            </div>
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("MFAAuthLabel")}
            </div>
            <div className="bbraun-hero-content">
              {localizationService.getLocalizedText("MFAAuthDesc")}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="bbraun-hero bbraun-hero-mutliple-rows">
            <div>
              <div className="bbraun-hero-headline">
                {localizationService.getLocalizedText("MFAAuthActionLabel")}
              </div>
              <div className="bbraun-hero-content">
                {localizationService.getLocalizedText("MFAAuthActionDesc")}
              </div>
            </div>
            <div>
              <img
                alt="BBraun_MFA_Logo"
                src={require("../../assets/images/MFA_BBraun.png")}
                data-midwidth="800"
                data-maxwidth="0"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row bbraun-green-bg">
        <div className="col-sm">
          <div className="bbraun-hero">
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("FAQLabel")}
            </div>
            <div className="bbraun-hero-content">
              <a className="bbraun-hero-button-link" href={faqUrl}>
                {localizationService.getLocalizedText("FAQButtonLabel")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prepare;
